import { render, staticRenderFns } from "./UpcomingLeavesComponent.vue?vue&type=template&id=c9bc3992&"
import script from "./UpcomingLeavesComponent.vue?vue&type=script&lang=ts&"
export * from "./UpcomingLeavesComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports